import { render, staticRenderFns } from "./SelectUnit.vue?vue&type=template&id=66aff0d2&scoped=true"
import script from "./SelectUnit.vue?vue&type=script&lang=js"
export * from "./SelectUnit.vue?vue&type=script&lang=js"
import style0 from "./SelectUnit.vue?vue&type=style&index=0&id=66aff0d2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aff0d2",
  null
  
)

export default component.exports